import React, { useEffect, useState } from "react";
import {
  Modal as MUIModal,
  Box,
  Typography,
  Button,
  IconButton,
  colors,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useGlobalState } from "../../contexts/GlobalContext";

const CommonModal: React.FC = () => {
  const { setModal, globalState } = useGlobalState();
  const { modalContext } = globalState;

  const handleModalHide = () => {
    if (globalState.modalContext?.onClose) {
      globalState.modalContext?.onClose();
    }
    setModal({
      isOpen: false,
      hideConfirmButton: false,
    });
  };

  const setModalDisabledConfirm = (value: boolean) => {
    setModal({
      ...globalState.modalContext,
      disabledConfirm: value,
    });
  };

  return (
    <MUIModal
      open={modalContext?.isOpen ?? false}
      disableAutoFocus
      disableEnforceFocus
      disablePortal
      className="modal-common"
    >
      <Box
        sx={{
          position: "absolute",
          top: "55%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          width: "90%",
          maxWidth: "900px",
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          borderBottom: "1px solid",
          borderEndEndRadius: "8px",
          borderEndStartRadius: "8px",
        }}
      >
        <div
          style={{
            padding: 10,
            borderBottom: "1px solid",
            borderBottomColor: "#E5E5E5",
          }}
          className="title-modal"
        >
          <IconButton
            onClick={() => handleModalHide()}
            sx={{
              borderRadius:"8px",
              border:"1px solid",
              borderColor:"lightgray",
              position: "absolute",
              top: -15,
              right: -15,
              backgroundColor: "#F0F0F0",
              "&:hover": {
                backgroundColor: "lightgray",
              },
            }}
          >
            <CloseIcon sx={{ color: "#21272A" }} />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h3"
            component="h3"
            sx={{
              fontSize: 16,
              fontWeight: 500,
              color: "#21272A",
              lineHeight: "35px",
            }}
          >
            {modalContext?.title}
          </Typography>
        </div>
        <Box sx={{ flex: 1 }}>{modalContext?.childrenTitle}</Box>
        <Box >
          <Box
            sx={{
              flex: 1,
              overflow: "hidden",
              p: 2,
            }}
          >
            <div
              style={{
                maxHeight: "calc(80vh - 200px)",
                overflowY: "auto",
                paddingRight: 8,
              }}
            >
              {modalContext?.childrenSession}
            </div>
          </Box>
          {modalContext?.showButton && (
            <Box
              sx={{
                borderTop: "1px solid",
                borderTopColor: "#E5E5E5",
                display: "flex",
                justifyContent: "center",
                gap: 2,
                mt: 3,
                padding: "10px",
              }}
            >
              <Button
                variant="outlined"
                onClick={() => handleModalHide()}
                sx={{
                  px: 1.5,
                  py: 2,
                  height: 24,
                  lineHeight: "100%",
                  fontSize: 14,
                  borderRadius: "8px",
                  boxShadow: "none",
                  backgroundColor: "white",
                  borderColor: "#F0F0F0",
                  color: "#007383",
                  "&:hover": {
                    backgroundColor: "#e8f0fe",
                  },
                }}
              >
                {modalContext?.cancelText}
              </Button>
              {modalContext?.onConfirm && (
                <Button
                  disabled={modalContext?.disabledConfirm || modalContext?.hideConfirmButton}
                  variant="outlined"
                  onClick={modalContext?.onConfirm}
                  sx={{
                    px: 1.5,
                    py: 2,
                    height: 24,
                    lineHeight: "100%",
                    fontSize: 14,
                    boxShadow: "none",
                    borderColor: "#F0F0F0",
                    backgroundColor: modalContext?.disabledConfirm || modalContext?.hideConfirmButton ? "#B0B0B0" : "#007383",
                    color: modalContext?.disabledConfirm || modalContext?.hideConfirmButton ? "#E0E0E0" : "#FFFFFF",
                    borderRadius: "8px",
                    cursor: modalContext?.disabledConfirm || modalContext?.hideConfirmButton ? "not-allowed" : "pointer",
                    "&:hover": {
                      backgroundColor: modalContext?.disabledConfirm || modalContext?.hideConfirmButton ? "#B0B0B0" : "#005f63",
                    },
                  }}
                >
                  {modalContext?.confirmText}
                </Button>
              )}
            </Box>
          )}
        </Box>
      </Box>
    </MUIModal>
  );
};
export const Modal = CommonModal;
